import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/login/login";
import Signup from "./pages/signup/signup";
import DashboardPage from "./pages/dashboard/dashboard";
import DocumentPage from "./pages/document/document";
import { screenPath } from "./constant/strings";
import DocumentViewer from "./pages/document_viewer/document_viewer";
import ChooseUser from "./pages/choose_user/choose_user";
import DashboardCompanyPage from "./pages/dashboard_company/dashboard_company";
import TransactionCompanyPage from "./pages/transaction_company/transaction_company";
import NewInvoiceCompanyPage from "./pages/new_invoice_company/new_invoice_company";
import LogExpensesCompanyPage from "./pages/log_expenses_company/log_expenses_company";
import RecordMileageCompanyPage from "./pages/record_mileage_company/record_mileage_company";
import BankStatementCompanyPage from "./pages/bank_statement_company/bank_statement_company";
import ReportsCompanyPage from "./pages/reports_company/reports_company";
import UploadDataCompanyPage from "./pages/upload_data_company/upload_data_company";
import ProfileCompanyPage from "./pages/profile_company/profile_company_page";
import AdminDashboard from "./pages/admin/admin_dashboard/admin_dashboard";
import AccountantSelectCompany from "./pages/accountant_select_company/SelectCompanyScreen";
import InvoicesAccountant from "./pages/invoice_accountant/InvoicesAccountant";
import ClientProfile from "./pages/accountant_company_profile/client_profile";
import ClientPage from "./pages/clients/client";
import AccountantEvents from "./pages/events_accountant/AccountantEvents";
import AccountantDocument from "./pages/accountant_document/AccountantDocument";
import AccountantEntries from "./pages/accountant_entries/AccountantEntries";
import AccountantReports from "./pages/accountant_reports/AccountantReports";
import AccountantExport from "./pages/accountant_export/AccountantExport";
import PersonalTaxPage from "./pages/personal_tax/PersonalTax";
import Users from "./pages/users/users";
import InviteAccept from "./pages/invite_accept/invite_accept";

function App() {
  return (
    <Router>
      <Routes>
        <Route path={screenPath.chooseUser} element={<ChooseUser />} />
        <Route path={screenPath.login} element={<Login />} />
        <Route path={screenPath.signup} element={<Signup />} />
        <Route path={screenPath.dashboardPage} element={<DashboardPage />} />
        <Route
          path={screenPath.personalTaxPage}
          element={<PersonalTaxPage />}
        />

        <Route
          path={screenPath.dashboardCompanyPage}
          element={<DashboardCompanyPage />}
        />
        <Route
          path={screenPath.transactionCompanyPage}
          element={<TransactionCompanyPage />}
        />
        <Route
          path={screenPath.newInvoiceCompanyPage}
          element={<NewInvoiceCompanyPage />}
        />
        <Route
          path={screenPath.logExpensesCompanyPage}
          element={<LogExpensesCompanyPage />}
        />
        <Route
          path={screenPath.recordMileageCompanyPage}
          element={<RecordMileageCompanyPage />}
        />
        <Route
          path={screenPath.bankStatementCompanyPage}
          element={<BankStatementCompanyPage />}
        />
        <Route
          path={screenPath.reportsCompanyPage}
          element={<ReportsCompanyPage />}
        />
        <Route
          path={screenPath.uploadDataCompanyPage}
          element={<UploadDataCompanyPage />}
        />
        <Route
          path={screenPath.profileCompanyPage}
          element={<ProfileCompanyPage />}
        />
        <Route
          path={screenPath.adminDashboard}
          element={<AdminDashboard />}
        />
        <Route path={screenPath.clientPage} element={<ClientPage />} />
        <Route path={screenPath.documentPage} element={<DocumentPage />} />
        <Route
          path={screenPath.accountantExports}
          element={<AccountantExport />}
        />
        <Route
          path={screenPath.clientProfilePage}
          element={<ClientProfile />}
        />
        <Route
          path={screenPath.documentViewerPage}
          element={<DocumentViewer />}
        />
        <Route
          path={screenPath.accountantSelectCompany}
          element={<AccountantSelectCompany />}
        />
        <Route
          path={screenPath.accountantInvoices}
          element={<InvoicesAccountant />}
        />
        <Route
          path={screenPath.accountantEvents}
          element={<AccountantEvents />}
        />
        <Route
          path={screenPath.accountantDocuments}
          element={<AccountantDocument />}
        />
        <Route
          path={screenPath.accountantEntries}
          element={<AccountantEntries />}
        />
        <Route
          path={screenPath.accountantReports}
          element={<AccountantReports />}
        />
        <Route path={screenPath.usersPage} element={<Users />} />
        <Route
          path={screenPath.inviteAccept}
          element={<InviteAccept />}
        />
        <Route
          path={`${screenPath.inviteAccept}/`}
          element={<InviteAccept />}
        />
      </Routes>
    </Router>
  );
}

export default App;
